var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2529 1.05762H3.74682C2.23249 1.05762 1 2.28986 1 3.80444V16.7729C1 16.7771 1.00073 16.7805 1.00073 16.7844C1.00098 16.7886 1.00122 16.7923 1.00147 16.7964C1.01418 18.3002 2.24007 19.5203 3.74682 19.5203H20.2527C21.7624 19.5203 22.9902 18.2963 22.9988 16.7886C22.999 16.7864 22.9993 16.7839 22.9993 16.782C22.9993 16.7788 22.9998 16.7764 22.9998 16.7732V3.80444C23 2.28986 21.7678 1.05762 20.2529 1.05762Z",
    fill: "#0060FF",
    fillOpacity: 0.2,
    stroke: "#0060FF",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2529 1.05762H3.74682C2.23249 1.05762 1 2.28986 1 3.80444V16.773C1 16.7771 1.00073 16.7805 1.00073 16.7844C1.00098 16.7886 1.00122 16.7923 1.00147 16.7964C1.01418 18.3002 2.24007 19.5203 3.74682 19.5203H20.2527C21.7624 19.5203 22.9902 18.2963 22.9988 16.7886C22.999 16.7864 22.9993 16.7839 22.9993 16.782C22.9993 16.7788 22.9998 16.7764 22.9998 16.7732V3.80444C23 2.28986 21.7678 1.05762 20.2529 1.05762ZM22.2217 15.7932L18.9535 12.3272C18.4492 11.7919 17.774 11.4971 17.0529 11.4971C16.3318 11.4971 15.6566 11.7917 15.1524 12.3272L12.9506 14.6622L9.7538 11.1744C9.25538 10.6308 8.58756 10.3316 7.87378 10.3316C7.15951 10.3316 6.49193 10.631 5.99376 11.1744L1.77831 15.7732V3.80444C1.77831 2.71886 2.66124 1.83544 3.74707 1.83544H20.2529C21.3388 1.83544 22.2219 2.71886 22.2219 3.80444V15.7932H22.2217Z",
    fill: "#0060FF",
    stroke: "#0060FF",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7161 8.36696C15.6302 8.36696 14.7471 7.48402 14.7471 6.3982C14.7471 5.31262 15.63 4.4292 16.7161 4.4292C17.8016 4.4292 18.6848 5.31262 18.6848 6.3982C18.6848 7.48402 17.8016 8.36696 16.7161 8.36696Z",
    fill: "#0060FF",
    stroke: "#0060FF",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhoto);
export default __webpack_public_path__ + "static/media/ic-photo.ddd24ddb9a2ffca1f5427275de595711.svg";
export { ForwardRef as ReactComponent };